export default "/images/camera-off.svg?7dbefbfd70a575bc4e88578c5e5f26de";